var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      !_vm.param.vendorFlag
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("c-table", {
                ref: "tableRisk",
                attrs: {
                  title: "위험등록부 목록",
                  tableId: "riskRegister01",
                  columns: _vm.gridRisk.columns,
                  data: _vm.riskReduce.riskbooks,
                  merge: _vm.gridRisk.merge,
                  gridHeight: _vm.setheight,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "customArea",
                      fn: function ({ props, col }) {
                        return [
                          col.name === "customCol"
                            ? [
                                props.row["sopImprovementIds"] &&
                                props.row["ibmStepNames"]
                                  ? _vm._l(
                                      _vm.$comm.ibmTagItems(
                                        props.row,
                                        _vm.colorItems
                                      ),
                                      function (item, index) {
                                        return _c(
                                          "q-chip",
                                          {
                                            key: index,
                                            staticStyle: {
                                              "margin-bottom": "4px !important",
                                            },
                                            attrs: {
                                              color: item.color,
                                              clickable: true,
                                              "text-color": "white",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.linkClick(
                                                  item,
                                                  props.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.title) + " "
                                            ),
                                            _c("c-assess-tooltip", {
                                              attrs: {
                                                ibmTooltip: item.ibmTooltip,
                                                ibmClassCd: item.ibmClassCd,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      }
                                    )
                                  : _vm._e(),
                              ]
                            : col.name === "picture"
                            ? [
                                _c("q-btn", {
                                  staticClass: "tableinnerBtn",
                                  attrs: {
                                    flat: "",
                                    align: "center",
                                    color: "blue-6",
                                    label: "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.openPicture(props, col)
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function () {
                                          return [
                                            props.row.editFlag !== "C"
                                              ? [_vm._v(" 사진 ")]
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ]
                            : _vm._e(),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  718646964
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("c-table", {
            ref: "tableImpr",
            attrs: {
              title: "개선 목록",
              tableId: "impr01",
              columns: _vm.gridImpr.columns,
              data: _vm.riskReduce.imprs,
              merge: _vm.gridImpr.merge,
              gridHeight: _vm.setheight,
            },
            on: { linkClick: _vm.linkClick },
          }),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }